// @flow
import * as React from 'react';
import styles from './modal.scss';
import Loader from '../loader/loader';

const closeIcnUrl = require('../../../assets/images/close_icn.svg');
const closeIcnWhiteUrl = require('../../../assets/images/close_icn_white.svg');
const backIcnWhiteUrl = require('../../../assets/images/back_icn.svg');

type Props = {
  children?: React.Node,
  showModal?: boolean,
  title?: string,
  closeModal: Function,
  showLoader?: boolean,
  modalTheme?: Object,
  onBackBtnClick?: Function,
  showCloseOption?: boolean,
  classNameProp?: string
};

const Modal = (props: Props) => {
  let customBodyStyles = {};
  if (props.customBodyStyles) {
    customBodyStyles = props.customBodyStyles;
  }
  return props.showModal ? (
    <div
      className={` ${
        props.modalTheme && props.modalTheme.name
          ? styles[props.modalTheme.name]
          : ''
      } ${styles.modalWrapper} modal-wrapper l-row j-center a-center ${
        props.classNameProp
      }`}
    >
      <div
        className={` ${styles.modalParent} modal-parent`}
        style={{
          minWidth: props.minWidth ? props.minWidth : '',
          maxHeight: props.maxHeight ? props.maxHeight : '',
          maxWidth: props.maxWidth ? props.maxWidth : ''
        }}
      >
        {props.showLoader ? (
          <div className={` ${styles.loaderParent} ${props.loaderStyles} `}>
            <Loader />
          </div>
        ) : null}

        <div className={`${styles.modalHeader} l-row j-space-bet`}>
          {props.modalTheme && props.modalTheme.showBackBtn ? (
            <div
              className={`${styles.backBtnWrapper} l-row a-center back-btn-wrapper`}
              onClick={() => props.onBackBtnClick && props.onBackBtnClick()}
            >
              <div className={`${styles.backIcn} l-row a-center`}>
                <img src={backIcnWhiteUrl} alt="" />{' '}
              </div>
              <div className="back-btn-label l-row a-center">BACK</div>
            </div>
          ) : null}
          {props.modalTheme &&
          props.modalTheme.titleCenter &&
          !props.modalTheme.showBackBtn ? (
            <div className={`${styles.dummyDivToKeepTitleInCenter}`}>---</div>
          ) : null}

          <div
            className={`${styles.modalTitle}  l-row a-center`}
            style={{ margin: 'auto' }}
          >
            {props.title}
          </div>
          {props.showCloseOption && (
            <div className="l-row a-center" onClick={() => props.closeModal()}>
              <img
                className={
                  props.modalTheme && props.modalTheme.closeIcnWhite
                    ? styles.modalCloseWhite
                    : styles.modalClose
                }
                src={
                  props.modalTheme && props.modalTheme.closeIcnWhite
                    ? closeIcnWhiteUrl
                    : closeIcnUrl
                }
                alt="close"
              />
            </div>
          )}
        </div>

        <div className={`${styles.modalBody}`} style={customBodyStyles}>
          {props.children}
        </div>
      </div>
      <div className={`${styles.modalBackdrop} modal-backdrop `} />
    </div>
  ) : null;
};

Modal.defaultProps = {
  children: '',
  showModal: false,
  title: 'Title Field',
  showLoader: false,
  modalTheme: {},
  showCloseOption: true,
  classNameProp: '',
  // eslint-disable-next-line
  onBackBtnClick: () => console.log('onBackBtnClick prop Missing')
};

export default Modal;
